<template>
  <el-tooltip :open-delay="1000" effect="dark" placement="bottom-end">
    <div slot="content" v-html="statusDesc" />
    <el-switch
      class="status-switch"
      :key="status"
      :value="statuses[status].value"
      :active-color="activeStatusColor"
      inactive-color="#ff4949"
    />
  </el-tooltip>
</template>

<script>
export default {
  name: "CameraStatus",
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      statuses: {
        active: {
          value: true,
          desc: "Камера включена",
        },
        not_active: {
          value: false,
          desc: "Камера временно выключена",
        },
        sleep: {
          value: false,
          desc: "Камера выключена и переведена в спящий режим из-за длительного периода неактивности",
        },
        test: {
          value: true,
          desc: "Камера включена, счет не выставляется",
        },
        deleted: {
          value: false,
          desc: "Камера удалена",
        },
      },
    };
  },
  computed: {
    statusDesc() {
      return this.statuses[this.status].desc;
    },
    activeStatusColor() {
      return this.status === "active" ? "#13ce66" : "#ffc216";
    },
  },
};
</script>

<style lang="scss">
.status-switch {
  &,
  & * {
    cursor: default;
  }
}
</style>
